import { useEffect, useState } from 'react';
import InpService from '../domain/ModelFile/InpService';
import { InpFile } from '@/domain/ModelFile/Inp';

const inpService = new InpService();

export default function useModelInfrastructure({
  inpId,
  typeId,
  page = 1,
  size = 10000,
  name = null,
  assetType = null,
}: {
  inpId: number;
  typeId: number;
  page?: number;
  size?: number;
  name?: string | null;
  assetType?: string | null;
}) {
  const [assets, setAssets] = useState<string[]>([]);
  const [pagination, setPagination] = useState({ page, size, totalRows: 0 });
  const [params, setParams] = useState<any>({
    inpId,
    typeId,
    name,
    assetType,
  });

  async function handleGetAssets() {
    if (!params.inpId || !params.typeId) return;
    const response = await inpService.getModelInfrastructureId({
      inpId: params.inpId,
      typeId: params.typeId,
      page,
      size,
      name: params.name,
      assetType: params.assetType,
    });
    setAssets(response.data);
    setPagination({ ...pagination, totalRows: response.totalRecords });
  }

  useEffect(() => {
    handleGetAssets();
  }, [
    pagination.page,
    pagination.size,
    params.name,
    params.inpId,
    params.typeId,
    params.assetType,
  ]);

  useEffect(() => {
    setParams((prev) => {
      return { ...prev, typeId };
    });
  }, [typeId]);

  useEffect(() => {
    setParams((prev) => {
      return { ...prev, inpId };
    });
  }, [inpId]);

  useEffect(() => {
    setParams((prev) => {
      return { ...prev, name };
    });
  }, [name]);

  useEffect(() => {
    setParams((prev) => {
      return { ...prev, assetType };
    });
  }, [assetType]);

  return { assets, pagination, params, setPagination, setParams };
}
